import { getTenantFromUrl } from 'xen/helpers'

export function tenantHeader() {
  return { 'tenant-token': getTenantFromUrl() }
}
